import { LevelXP, addDamageText, addParticle, randomIntRange, enemies, rectanglesIntersect, spawnEnemyParticles, settings, randomJitter } from './game.js'
import { drawImage, getContext } from './images.js'
import { tileset, currentLevel, CoordinatesToTileIndex, GetEnemiesInRange, spawnBloodParticles, GetGemsInRange } from './game.js'
import { playSfx } from './sfx.js'

class Player {
    constructor(x, y) {
        this.x = x
        this.y = y
        this.w = 10
        this.h = 12
        this.movement = { x: 0, y: 0 }
        this.oldMovement = { x: 0, y: 0 }
        this.force = { x: 0, y: 0, friction: 0.1, minX: 0.03, minY: 0.03 }
        this.speed = 0.03
        this.revives = 3

        this.maxHp = 20
        this.hp = this.maxHp

        this.level = 1
        this.xp = 0
        this.maxXp = LevelXP(this.level)

        this.dead = false

        this.score = 0

        this.character = 'Knight'
        this.state = 'Idle'
        this.substate = ''

        this.flipped = false

        this.animationFrame = 0
        this.animationFramesCount = 4
        this.animationSpeed = 0.005

        this.ctx = getContext()

        this.stats = {
            cooldown: {
                melee: 0,
                projectile: 0,
                area: 1000,
                duration: {
                    melee: 2000,
                    projectile: 3000,
                    area: 5000
                }    
            },
            speed: {
                projectile: 0.01
            },
            damage: {
                melee: 0.4,
                projectile: 0.2,
                area: 0.15,
                range: {
                    melee: 12,
                    projectile: 40,
                    area: 15
                }
            },
            active: {
                melee: 0,
                projectile: 0,
                area: 0,
                duration: {
                    melee: 600,
                    projectile: 3000,
                    area: 2000
                }    
            },
            level: {
                melee: 1,
                projectile: 0,
                projectileCount: 1,
                area: 0
            },
            gemCollect: {
                range: 20,
                pickupRange: 5,
                speed: 0.01,
                xpfactor: 1
            },
            knockback: {
                melee: {
                    speed: 0.3
                },
                projectile: {
                    speed: 0.25
                },
                area: {
                    speed: 0.35
                }
            }
        }
        this.originalStats = JSON.parse(JSON.stringify(this.stats))
    }

    AngleBetween(x, y) {
        let dx = this.x - x
        let dy = this.y - y
        return Math.atan2(dy, dx)
    }

    AddForce(angle, amt) {
        let velX = Math.cos(angle) * amt
        let velY = Math.sin(angle) * amt
        this.force.x += velX
        this.force.y += velY
    }

    AnimationFrame(frame) {
        if (frame !== undefined) {
            this.animationFrame = frame
        }
        return parseInt(this.animationFrame)
    }

    ShouldAnimationPlay() {
        return true
    }

    AnimationAdvance(delta) {
        if (!this.ShouldAnimationPlay()) {
            return parseInt(this.animationFrame)
        }
        this.animationFrame += delta * this.animationSpeed

        if (this.state === 'Attack' && parseInt(this.animationFrame) === this.animationFramesCount - 2) {
            let enemies = GetEnemiesInRange().filter(f => !f.dead && f.state !== 'Hurt')
            enemies.forEach(enemy => {
                if ((!this.flipped && enemy.x <= this.x) || (this.flipped && enemy.x > this.x)) {
                    let dmg = Math.ceil(this.stats.damage.melee * delta)
                    enemy.Damage(dmg)
                    addDamageText(dmg, enemy.x, enemy.y)
                    // Apply knockback
                    let angle = enemy.AngleBetween(this.x, this.y)
                    enemy.AddForce(angle, this.stats.knockback.melee.speed)
                    let index = randomIntRange(1, 2) - 1
                    let sfx = ['hurt', 'hurt2'][index]
                    playSfx(sfx)
                }
            })
        }

        if (this.animationFrame >= this.animationFramesCount) {
            this.animationFrame = 0
            if (['Attack', 'Hurt'].includes(this.state)) {
                this.SetAnimation('Idle')
            } else if (this.state === 'Death') {
                this.animationFrame = this.animationFramesCount - 1
                this.dead = true
            }
        }
        return parseInt(this.animationFrame)
    }

    ApplyUpgrade(upgrade) {
        console.log('this.ApplyUpgrade', upgrade.statPath)
        if (upgrade.statPath === 'hp') {
            let amt = upgrade.statAmount * this.maxHp
            eval('this.' + upgrade.statPath + '+=' + amt)
        } else if (upgrade.statPath === 'maxHp') {
            let amt = upgrade.statAmount * this.maxHp
            eval('this.' + upgrade.statPath + '+=' + amt)
        } else if (upgrade.statPath === 'speed') {
            let amt = upgrade.statAmount * this.speed
            eval('this.' + upgrade.statPath + '+=' + amt)
        } else if (upgrade.statPath === 'incrementProjectileCount') {
            this.stats.level.projectileCount += upgrade.statAmount
        }
        else {
            let amt = upgrade.statAmount * eval('this.' + upgrade.statPath)
            eval('this.' + upgrade.statPath + ' += ' + amt)
            let path = upgrade.statPath.split('.')
            if (['melee', 'projectile', 'area'].includes(path[path.length - 1])) {
                this.stats.level[path[path.length - 1]]++
            }
        }
    }

    SetAnimation(state) {
        this.state = state
        this.animationFrame = 0
    }

    Draw(offsetx, offsety) {
        drawImage(this.character + '-' + this.state, parseInt(this.x + offsetx) - 6, parseInt(this.y + offsety) - 4, { x: this.AnimationFrame() * 10, y: 0, w: this.w, h: this.h }, this.flipped)
    }

    Damage(amt) {
        this.hp -= amt
        settings.screenShakeValue = randomJitter(0.6, 1.3)
        if (this.hp <= 0) {
            this.hp = 0
            if (this.state !== 'Death' && !this.dead) {
                this.SetAnimation('Death')
            }
        } else {
            this.SetAnimation('Hurt')
            this.stats.cooldown.melee = this.stats.cooldown.duration.melee
            spawnBloodParticles(this.x, this.y)
        }
    }

    ApplyFriction() {
        this.force.x -= this.force.x * this.force.friction
        this.force.y -= this.force.y * this.force.friction

        if (
            (this.force.x > 0 && this.force.x <= this.force.minX) ||
            (this.force.y > 0 && this.force.y <= this.force.minY)
        ) {
            this.force.x = 0
        }

        if (
            (this.force.x < 0 && this.force.x >= -this.force.minX) ||
            (this.force.y < 0 && this.force.y >= -this.force.minY)
        ) {
            this.force.y = 0
        }
    }

    UpdateStats(delta) {
        this.stats.cooldown.melee -= delta
        if (this.stats.cooldown.melee <= 0) {
            this.stats.cooldown.melee = this.stats.cooldown.duration.melee
            if (this.state === 'Idle') {
                this.SetAnimation('Attack')
            }
        }

        this.stats.cooldown.projectile -= delta
        if (this.stats.cooldown.projectile <= 0 && this.stats.level.projectile > 0) {
            this.stats.cooldown.projectile = this.stats.cooldown.duration.projectile
            for (let proj = 0; proj < this.stats.level.projectileCount; proj++) {
                setTimeout(() => {
                    let deltax = this.oldMovement.x * delta * this.stats.speed.projectile
                    let deltay = this.oldMovement.y * delta * this.stats.speed.projectile
            
                    let newx = this.x + deltax
                    let newy = this.y + deltay
        
                    let dx = newx - this.x
                    let dy = newy - this.y
                    let angle = Math.atan2(dy, dx)
                    let velX = Math.cos(angle) * this.stats.speed.projectile * delta
                    let velY = Math.sin(angle) * this.stats.speed.projectile * delta
                    let part = addParticle('Arrow', this.x + randomJitter(-2, 2), this.y + randomJitter(-2, 2), velX, velY, 'source-over', undefined, (p, delta) => {
                        if (this.DistanceTo(p.x, p.y) > this.stats.damage.range.projectile) {
                            p.Destroy()
                        } else {
                            enemies.forEach(enemy => {
                                let rect = { x: parseInt(enemy.x) - 4, y: parseInt(enemy.y) + 2, w: enemy.w - 4, h: enemy.h - 6 }
                                if (rectanglesIntersect(p.x, p.y, p.x + p.w, p.y + p.h, rect.x, rect.y, rect.x + rect.w, rect.y + rect.h)) {
                                    p.Destroy()
                                    let dmg = Math.ceil(this.stats.damage.projectile * delta)
                                    enemy.Damage(dmg)
                                    spawnEnemyParticles(enemy.particleImage, enemy.x, enemy.y)
                                    addDamageText(dmg, enemy.x, enemy.y)
                                    // Apply knockback
                                    let angle = enemy.AngleBetween(this.x, this.y)
                                    enemy.AddForce(angle, this.stats.knockback.projectile.speed)
                                    let index = randomIntRange(1, 2) - 1
                                    let sfx = ['hurt', 'hurt2'][index]
                                    playSfx(sfx)
                                }
                            })
                        }
                    })
                    part.animationSpeed = 0
                    part.w = 10
                    part.h = 10
                    part.friction = 0
                    part.destroyAfterAnimation = false
                    let angleDeg = angle * (180 / Math.PI)
                    // Right
                    if (angleDeg === 0) {
                        part.animationFrame = 5
                    }
                    // Down
                    if (angleDeg === 90) {
                        part.animationFrame = 3
                    }
                    // Left
                    if (angleDeg === 180) {
                        part.animationFrame = 1
                    }
                    // Up
                    if (angleDeg === -90) {
                        part.animationFrame = 7
                    }
                    
                    if (angleDeg > -90 && angleDeg < 0) {
                        part.animationFrame = 6
                    }
        
                    if (angleDeg < 90 && angleDeg > 0) {
                        part.animationFrame = 4
                    }
        
                    if (angleDeg > 90 && angleDeg < 180) {
                        part.animationFrame = 2
                    }
                }, proj * 300)
            }

        }

        this.stats.cooldown.area -= delta
        if (this.stats.cooldown.area <= 0) {
            this.stats.cooldown.area = this.stats.cooldown.duration.area
            this.stats.active.area = this.stats.active.duration.area
        } else {
            this.stats.active.area -= delta
            this.stats.active.area = this.stats.active.area < 0 ? 0 : this.stats.active.area
        }

        if (this.stats.active.area > 0 && this.stats.level.area > 0) {
            let enemies = GetEnemiesInRange(this.stats.damage.range.area).filter(f => !f.dead && f.state !== 'Hurt')
            enemies.forEach(enemy => {
                let dmg = Math.ceil(this.stats.damage.area * delta)
                enemy.Damage(dmg)
                addDamageText(dmg, enemy.x, enemy.y)
                // Apply knockback
                let angle = enemy.AngleBetween(this.x, this.y)
                enemy.AddForce(angle, this.stats.knockback.area.speed)
                let index = randomIntRange(1, 2) - 1
                let sfx = ['hurt', 'hurt2'][index]
                playSfx(sfx)
            })
        }
    }

    DistanceTo(x, y) {
        return Math.sqrt( Math.pow((this.x-x), 2) + Math.pow((this.y-y), 2) )
    }

    Update(delta) {
        this.AnimationAdvance(delta)

        if (this.dead) {
            return
        }

        if (this.state !== 'Death') {
            // Apply movement vector to position.
            let dx = this.movement.x * delta * this.speed
            let dy = this.movement.y * delta * this.speed
    
            this.x += dx
            this.y += dy
        }

        // Apply force vector to position.
        let fx = this.force.x * delta
        let fy = this.force.y * delta

        this.x += fx
        this.y += fy

        this.ApplyFriction()

        this.UpdateStats(delta)

        let gems = GetGemsInRange()
        if (gems.length > 0) {
            gems.forEach(gem => {
                let dx = this.x - gem.x - 4
                let dy = this.y - gem.y
                let angle = Math.atan2(dy, dx)
                let velX = Math.cos(angle) * this.stats.gemCollect.speed
                let velY = Math.sin(angle) * this.stats.gemCollect.speed
                gem.x += velX * delta
                gem.y += velY * delta
            })
        }

        // let index = CoordinatesToTileIndex(parseInt(this.x / tileset.tilewidth), parseInt(this.y / tileset.tileheight))
        // let tileIndex = currentLevel.layers[0].data[index] - 1
        // let baseTile = tileset.tiles.filter(f => f.id === tileIndex)
        // if (baseTile.length > 0 && baseTile[0].class === 'Water') {
        //     this.standingInWater = true
        // } else {
        //     this.standingInWater = false
        // }

        // TODO: If melee/projectile/area cooldown is > 0, decrement by delta time.
        // TODO: If melee/projectile/area active is > 0, apply damage to enemies in range and decrement by delta time.
        // TODO: If melee/projectile/area active == 0, set cooldown to duration.

        if (this.oldMovement.x !== this.movement.x && !(this.movement.x === 0 && this.movement.y === 0)) {
            this.oldMovement.x = this.movement.x
        }
        if (this.oldMovement.y !== this.movement.y && !(this.movement.x === 0 && this.movement.y === 0)) {
            this.oldMovement.y = this.movement.y
        }
    }
}

export default Player